/* Network utilities. */

/** Shortcut for sending JSON data via POST. */
export function postJSON(url: string, data: Object, success: any, args?: JQuery.AjaxSettings): JQuery.jqXHR {
    args = $.extend({
        url: url,
        type: "POST",
        data: JSON.stringify(data),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: success
    }, args);
    return $.ajax(args);
};

/** Shortcut for sending Form data via POST. */
export function postFormData(url: string, data: Object, success: any, args?: JQuery.AjaxSettings): JQuery.jqXHR {
    args = $.extend({
        url: url,
        type: "POST",
        data: data,
        encType: 'multipart/form-data',
        contentType: false,
        processData: false,
        success: success
    }, args);
    return $.ajax(args);
};
